import { render, staticRenderFns } from "./transWarehouseIn.vue?vue&type=template&id=38a01764&scoped=true&"
import script from "./transWarehouseIn.vue?vue&type=script&lang=js&"
export * from "./transWarehouseIn.vue?vue&type=script&lang=js&"
import style0 from "./transWarehouseIn.vue?vue&type=style&index=0&id=38a01764&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a01764",
  null
  
)

component.options.__file = "transWarehouseIn.vue"
export default component.exports